/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketStatusResponseItem } from '../../models/ticket-status-response-item';
import { UpdateTicketStatusDto } from '../../models/update-ticket-status-dto';

export interface TicketStatusControllerUpdate$Params {

/**
 * Ticket status ID
 */
  id: number;
      body: UpdateTicketStatusDto
}

export function ticketStatusControllerUpdate(http: HttpClient, rootUrl: string, params: TicketStatusControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketStatusControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketStatusResponseItem;
      }>;
    })
  );
}

ticketStatusControllerUpdate.PATH = '/ticket-status/{id}';
